var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRawDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon data raw",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 15V3a1 1 0 0 1 1-1 1 1 0 0 1 1 1v12a1 1 0 0 1-1 1 1 1 0 0 1-1-1zm-3 0V7a1 1 0 0 1 1-1 1 1 0 0 1 1 1v8a1 1 0 0 1-1 1 1 1 0 0 1-1-1zm-3 0V5a1 1 0 0 1 1-1 .993.993 0 0 1 1 1v10a.993.993 0 0 1-1 1 1 1 0 0 1-1-1zm-3 0V8a1 1 0 0 1 1-1 1 1 0 0 1 1 1v7a1 1 0 0 1-1 1 1 1 0 0 1-1-1zm-3 0V5a1 1 0 0 1 1-1 1 1 0 0 1 1 1v10a1 1 0 0 1-1 1 1 1 0 0 1-1-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawDataIcon);
export default __webpack_public_path__ + "static/media/raw-data-icon.99c6ba146b4237ce4c451cb47feab9c8.svg";
export { ForwardRef as ReactComponent };